import { createContext, useState } from "react";

export const BurgerMenuContext = createContext();

export const BurgerMenuProvider = ({ children }) => {
  const [menuOpenState, setMenuOpenState] = useState(false);

  const value = {
    isMenuOpen: menuOpenState,
    toggleMenu: () => setMenuOpenState(!menuOpenState),
    stateChangeHandler: (newState) => setMenuOpenState(newState.isOpen),
  };
  return (
    <BurgerMenuContext.Provider value={value}>
      {children}
    </BurgerMenuContext.Provider>
  );
};
